module.exports = __webpack_public_path__ + "static/media/projects.a3a5ef2d.svg";